module.exports = __webpack_public_path__ + "static/img/Silhouettes-Femme.2958f2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/Silhouettes-Femme.svg
// module id = Gf09
// module chunks = 1